// extracted by mini-css-extract-plugin
module.exports = {"footer":"index__footer___Dc4dh","column":"index__column___3JvZ0","checkboxGroup":"index__checkboxGroup___8FPJ9"};